import Vue from 'vue';
import VueRouter from 'vue-router';
import router1 from './router1.js'; // 路由1
import router2 from './router2.js'; // 路由2

Vue.use(VueRouter);

const routers = [].concat(router1, router2);

// 初始化路由
const router = new VueRouter({
    mode: "history",//注释后打包才正常,不注释本地正常
    routes: routers,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
router.beforeEach(async (to, from, next) => {
    // 路由变化修改网页title及meta
    if (to.meta.content) {
        const { keywords, description } = to.meta.content;
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        keywords && document.querySelector('meta[name="keywords"]').setAttribute('content', keywords);
        description && document.querySelector('meta[name="description"]').setAttribute('content', description);
        head[0].appendChild(meta);
    }
    next();
});
export default router;
